import * as yup from "yup";

export type TurnoverItem = {
  mr_product_turnover_code: string;
  rule: string;
  min_value: number;
  max_value: number | null;
  description: string;
};

export const turnoverSchema = yup.object({
  items: yup
    .array()
    .of(
      yup.object({
        mr_product_turnover_code: yup.string().required(),

        rule: yup.string().required(),

        min_value: yup.number().required(),

        max_value: yup
          .number()
          .nullable()
          .defined()
          .when("mr_product_turnover_code", {
            is: (val: string) => val !== "04",
            then: (schema) =>
              schema
                .required("Max value is reuired")
                .moreThan(
                  yup.ref("min_value"),
                  "Max must greater than Min"
                ),
            otherwise: (schema) => schema.nullable().defined()
          }),

        description: yup.string().required("Description is required")
      })
    )
    .required()
    .defined()
});
